import { getDocumentObject } from '../common/utils/commonUtils'
import { FLAGS_PARAM_NAME } from '../flags/useFlags'

export const getIsMixpanelDebugEnabled = () => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    return devFlags ? JSON.parse(devFlags).enableMixpanelDebug : false
  }
  return false
}

export const toggleEnableMixpanelDebugWeb = () => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    const enableMixpanelDebug = getIsMixpanelDebugEnabled()

    const newFlags = JSON.parse(devFlags ?? '{}')
    if (enableMixpanelDebug) {
      delete newFlags.enableMixpanelDebug
    } else {
      newFlags.enableMixpanelDebug = true
    }
    localStorage.setItem(FLAGS_PARAM_NAME, JSON.stringify(newFlags))
    window.location.reload()
  }
}
